import $ from "jquery";
import _ from "underscore";
import "./enso-plugins.js";

var WHITELIST_BLOCK_TAGS = [
  "p",
  "blockquote",
  "ul",
  "li",
  "h1",
  "h2",
  "h3",
  "h4"
];
var WHITELIST_INLINE_TAGS = ["a", "p", "b", "strong", "em", "i", "br", "sub"];
var WHITELIST_TAGS = WHITELIST_BLOCK_TAGS.concat(WHITELIST_INLINE_TAGS);

/**
 * this decorator takes as its argument a function that takes a jQuery element and applies some manipuations on it.
 * The decorator takes care of converting the following types into jquery element:
 *  - a string containg html
 *  - an element of type Node (javascript native DOM node)
 *  - jQuery types remain unconvertor
 * Finally, after the funciont returns the data is converted back to the original type.
 * This way, when writing a manipulation function, you only need to deal with jQuery objects and the
 * decorator takes care of converting back and forth.
 *
 * @param func
 * @returns {Function}
 */
var HtmlTransformerDecorator = function(func) {
  return function(x) {
    var x = arguments[0];
    var extraArgs = Array.prototype.slice.call(arguments, 1);

    var STRING = "STRING";
    var DOM_ELEMENT = "DOM_ELEMENT";
    var DOM_FRAGMENT = "DOM_FRAGMENT";
    var JQUERY_ELEMENT = "JQUERY_ELEMENT";
    var JQUERY_FRAGMENT = "JQUERY_FRAGMENT";

    var dataFormat;
    if (typeof x === "string") {
      dataFormat = STRING;
    } else if (x instanceof Element) {
      dataFormat = DOM_ELEMENT;
    } else if (x instanceof DocumentFragment) {
      dataFormat = DOM_FRAGMENT;
    } else if (x instanceof jQuery) {
      if (x[0].parentNode instanceof DocumentFragment) {
        dataFormat = JQUERY_FRAGMENT;
      } else {
        dataFormat = JQUERY_ELEMENT;
      }
    }

    //todo: consider [jQuery] and [Node] as types
    var $e;
    if (dataFormat == "STRING") {
      $e = $("<wrapper>").append(x); //put in wrapper so there is a single root node. wrapper is removed on output
    } else if (dataFormat == DOM_ELEMENT || dataFormat == DOM_FRAGMENT) {
      $e = $(x);
    } else if (dataFormat == JQUERY_ELEMENT || dataFormat == JQUERY_FRAGMENT) {
      $e = x;
    }
    var args = [$e].concat(extraArgs);
    func.apply(this, args);

    switch (dataFormat) {
      case STRING:
        return $e.html(); //uses innerHTML, so the <wrapper> tag is removed
      case JQUERY_ELEMENT:
      case JQUERY_FRAGMENT:
        return $e;
      case DOM_ELEMENT:
      case DOM_FRAGMENT:
        return $e.get(0);
    }
  };
};

var removeAttributesRecursive = HtmlTransformerDecorator(function($e) {
  $e.removeAttributesRecursive();
});

var removeElementKeepContents = HtmlTransformerDecorator(function($e) {
  var $new = $e.contents();
  $("<br>").appendTo($new);
  $e.replaceWith($new);
  return $e;
});

var cleanKeepWhiteListTags = HtmlTransformerDecorator(function($e) {
  // todo: ability to specify tags... eg: severe, moderate, etc
  var e = $e.get(0);
  var view = this;
  var tag = e.tagName.toLowerCase();
  if (!_.contains(WHITELIST_TAGS, tag)) {
    $e = removeElementKeepContents($e);
  }
  $e.children().each(function(i, e) {
    cleanKeepWhiteListTags($(e));
  });
});

var clearInlineFormatting = HtmlTransformerDecorator(function($e) {
  var view = this;

  var _clearInlineFormatting = function(e) {
    if (!_.contains(WHITELIST_BLOCK_TAGS, e.tagName.toLowerCase())) {
      removeElementKeepContents(e);
      return true;
    } else {
      return false;
    }
  };

  var elementsRemoved = false;
  while (elementsRemoved) {
    $e.children().each(function(i, e) {
      elementsRemoved = _clearInlineFormatting(e);
    });
  }
  $e.children().each(function(i, e) {
    elementsRemoved = clearInlineFormatting(e);
  });

  _clearInlineFormatting($e.get(0));
});

var removeEmptyNodes = HtmlTransformerDecorator(function($e) {
  $e.removeEmptyNodes();
});

export var cleanHtml = HtmlTransformerDecorator(function($e, userOptions) {
  var userOptions = typeof userOptions !== "undefined" ? userOptions : {};

  var options = {
    keepOnlyWhitelistTags: true,
    removeAttributesRecursive: true,
    removeInlineTags: true,
    removeEmptyNodes: true
  };

  //TODO: decorator needs to support indefinite length arguments

  _.extend(options, userOptions);

  console.log(options);

  serverSideHtmlTidy($e);

  $e.children().each(function(i, e) {
    console.log(e);
    removeAttributesRecursive($(e));
  });

  var functions = {
    keepOnlyWhitelistTags: function() {
      $e.children().each(function(i, e) {
        cleanKeepWhiteListTags(e);
      });
    },
    removeAttributesRecursive: function() {
      $e.children().each(function(i, e) {
        removeAttributesRecursive($(e));
      });
    },
    removeInlineTags: function() {
      $e.children().each(function(i, e) {
        clearInlineFormatting(e);
      });
    },
    removeEmptyNodes: function() {
      removeEmptyNodes($e);
    }
  };

  $.each(options, function(option, enabled) {
    console.log(option);
    if (enabled) {
      functions[option]();
    }
  });
});

export var ensoPasteCleanup = HtmlTransformerDecorator(function($e) {
  $e.removeClassesRecursive();
  return cleanHtml($e, { removeInlineTags: false });
});

var serverSideHtmlTidy = HtmlTransformerDecorator(function($e) {
  // completely override Redactor's crappy regex paste cleanup and do it server side.
  var response = $.ajax({
    //            async: false,  // just so we don't have to deal with callbacks!
    url: "/api/cms/html-tidy/", //local htmltidy service
    data: { html: $e.getOuterHtml() },
    dataType: "json",
    method: "post"
  });
  $e.replaceWith(response.tidy_html);
});



// WEBPACK FOOTER //
// ./enso_cms/static/enso-cms/js/enso-html-cleanup.js